export default {"src":"/_next/static/media/cost-effective.ce83feaa.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};